import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import plus from "../../../Components/assets/icons/a1.png";
import search1 from "../../../Components/assets/icons/search.png";
import Table from "react-bootstrap/Table";
import { Link } from "react-router-dom";
import Header from "../../Header/Header";
import { Context } from "../../../utils/context";
import { Toaster } from "react-hot-toast";
import AddOffCanvance from "./Add";
import EditOffCanvance from "./Edit";
import ModalDelete from "../../common/ModelDelete";
import { EditButton, DeletButton } from "../../common/Button";
import { Button } from "react-bootstrap";
import { formatDate, IDS } from "../../../utils/common";
import Pagination_Holder from "../../common/Pagination_Holder/Pagination_Holder";
import parse from "html-react-parser";

// Career used the Brand permission ids. Add a Career entry to IDS and this switches over by itself.
const PERM = IDS.Career || IDS.Brand;

const joinNames = (rows, key) =>
  (rows || []).map((r) => r?.[key]?.name).filter(Boolean).join(", ");

const Tables = () => {
  const { getData, deleteData, ErrorNotify, Per_Page_Dropdown, isAllow } = useContext(Context);

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setperPage] = useState(5);
  const [search, setSearch] = useState("");
  const [reset, setReset] = useState();
  const [show, setShowAdd] = useState(false);
  const [show1, setShowEdit] = useState(0);
  const [changeStatus, setChangeStatus] = useState();
  const [option, setOption] = useState();
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);

  const getDataAll = async () => {
    const response = await getData(
      `/admin/career/career-form?page=${onPageChange}&per_page=${perPage}&term=${encodeURIComponent(search || "")}`
    );
    setData(response);
    setCurrentPage(response?.data?.current_page || 1);
    settotalPages(response?.data?.total_pages);
    setOption(await Per_Page_Dropdown(response?.data?.total));
  };

  useEffect(() => {
    getDataAll();
    // eslint-disable-next-line
  }, [changeStatus, perPage, reset, show, show1, onPageChange]);

  // Delete
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [recordToDeleteId, setRecordToDeleteId] = useState(null);
  const [recordToDeleteName, setRecordToDeleteName] = useState(null);

  const showDeleteRecord = (id, name) => {
    setShowDeleteModal(true);
    setRecordToDeleteId(id);
    setRecordToDeleteName(name);
  };

  const handleDeleteRecord = async () => {
    setShowDeleteModal(false);
    if (recordToDeleteId) {
      const response = await deleteData(`/admin/career/career-form/${recordToDeleteId}`);
      ErrorNotify(recordToDeleteName);
      setRecordToDeleteId(null);
      setRecordToDeleteName(null);
      setChangeStatus(response);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteModal(false);
    setRecordToDeleteId(null);
    setRecordToDeleteName(null);
  };

  const rows = data?.data?.data || [];
  const total = data?.data?.total || 0;
  const size = Number(perPage) || 5;
  const from = total ? (currentPage - 1) * size + 1 : 0;
  const to = Math.min(currentPage * size, total);

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Career"} link={"/admin/career/career-form"} />
        <section className="AdvanceDashboard">
          <div className="col-lg-12 p-0">
            <div className="row MainRowsec me-0 ms-0">
              <section className="Tabels tab-radio tab-radio">
                <div className="">
                  <div className="row">
                    <div className="col-xxl-2 col-xl-2 col-lg-4 col-md-6 col-sm-6 col-12">
                      <div className="add me-3">
                        {isAllow?.includes(PERM.Add) && (
                          <Link type="button" className="btn btn-add pe-3">
                            <div onClick={() => setShowAdd(true)}>
                              <img src={plus} className="plus me-2 ms-0" alt="" />
                              Add Career
                            </div>
                          </Link>
                        )}
                      </div>
                    </div>

                    <div className="border-line mt-3"></div>
                    <div className="row mt-3">
                      <div className="col-12">
                        <div className="d-flex align-items-center mb-1">
                          <div className="show me-2">
                            <p className="show m-0">Show</p>
                          </div>
                          <div className="number me-2">
                            <select
                              className="form-select form-select-sm"
                              aria-label=".form-select-sm example"
                              onChange={(e) => {
                                setonPageChange(1);
                                setperPage(e.target.value);
                              }}
                            >
                              {option?.map((o) => (
                                <option key={o} value={o}>
                                  {o}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="entries">
                            <p className="show m-0">entries</p>
                          </div>
                          <div className="sowing ms-3 me-2">
                            <p className="show m-0">{`Showing ${from} to ${to} of ${total} entries`}</p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="row align-items-start">
                          <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 col-sm-6 col-12 mb-2">
                            <div className="num">
                              <label className="form-label"></label>
                              <input
                                type="text"
                                className="form-control"
                                value={search}
                                placeholder="Search Career"
                                onChange={(e) => setSearch(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-xxl-1 col-xl-2 col-lg-2 col-md-2 col-sm-6 col-12 mb-2">
                            <label className="form-label">Search</label>
                            <div className="Search">
                              <Button
                                type="button"
                                onClick={() => {
                                  setonPageChange(1);
                                  getDataAll();
                                }}
                                className="btn btn-search"
                              >
                                <img src={search1} className="search" alt="" />
                              </Button>
                            </div>
                          </div>
                          <div className="col-xxl-1 col-xl-2 col-lg-2 col-md-2 col-sm-6 col-12 mb-2">
                            <label className="form-label">Reset</label>
                            <div className="Search-1">
                              <button
                                type="button"
                                onClick={() => {
                                  setSearch("");
                                  setonPageChange(1);
                                  setReset(!reset);
                                }}
                                className="btn btn-reset"
                              >
                                Reset
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="border-line mt-3"></div>
                  <div className="row mt-3">
                    <div className="data table-responsive">
                      <Table striped bordered hover responsive center>
                        <thead>
                          <tr>
                            <th className="sr">Sr. No.</th>
                            <th className="tax-name">Name</th>
                            <th className="tax-name">Skill</th>
                            <th className="tax-name">Job Location</th>
                            <th className="tax-name">Role Permission</th>
                            <th className="active">HR Name</th>
                            <th className="active">Recruiter Email</th>
                            <th className="active">Job Type</th>
                            <th className="active">Shift Type</th>
                            <th className="active">Recruiter Contact</th>
                            <th className="active">Start Annual Package</th>
                            <th className="active">End Annual Package</th>
                            <th className="active">Company Name</th>
                            <th className="active">Vacancy</th>
                            <th className="active">Experience From</th>
                            <th className="active">Experience To</th>
                            <th className="active">Deadline</th>
                            <th className="active">Language</th>
                            <th className="active">Qualification</th>
                            <th className="active">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {rows.map((d, index) => (
                            <tr key={d?.id ?? index}>
                              <td>{(onPageChange - 1) * size + index + 1}.</td>
                              <td className="width_dertails_name_div">{d?.name}</td>
                              <td>{d?.skill}</td>
                              <td>{d?.job_location}</td>
                              <td>{parse(d?.role_permission || "")}</td>
                              <td>{d?.hr_name}</td>
                              <td>{d?.recruiter_email}</td>
                              <td>{d?.JobType?.name}</td>
                              <td>{d?.Shift?.name}</td>
                              <td>{d?.recruiter_contact_number}</td>
                              <td>{d?.start_annual_package}</td>
                              <td>{d?.end_annual_package}</td>
                              <td>{d?.company_name}</td>
                              <td>{d?.vacancy}</td>
                              <td>{d?.experience_from}</td>
                              <td>{d?.experience_to}</td>
                              <td>{d?.deadline ? formatDate(d.deadline) : ""}</td>
                              <td>{joinNames(d?.Career_languages, "Language")}</td>
                              <td>{joinNames(d?.Career_Qualifications, "Qualification")}</td>
                              <td>
                                <div className="d-flex">
                                  {isAllow?.includes(PERM.Edit) && (
                                    <EditButton handleShow1={(id) => setShowEdit(id)} id={d?.id} />
                                  )}
                                  {isAllow?.includes(PERM.Delete) && (
                                    <DeletButton showDeleteRecord={showDeleteRecord} id={d?.id} name={d?.name} />
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                      {rows.length > 0 ? (
                        <Pagination_Holder
                          onPageChange={currentPage}
                          totalPages={totalPages}
                          handlePageChange={setonPageChange}
                        />
                      ) : (
                        <p className="no-datashow">Sorry, No Data Found</p>
                      )}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </section>
      </div>

      {show ? <AddOffCanvance handleClose={() => setShowAdd(false)} setShow={setShowAdd} show={show} /> : ""}
      {show1 ? <EditOffCanvance handleClose={() => setShowEdit(0)} setShow={setShowEdit} show={show1} /> : ""}

      <ModalDelete show={showDeleteModal} handleDeleteRecord={handleDeleteRecord} handleDeleteCancel={handleDeleteCancel} />
      <Toaster position="top-right" />
    </>
  );
};

export default Tables;